import ajax from "../util/ajax";

export const baseUrlByEnvironment = () => {
  // Адрес API можно переопределить через REACT_APP_API_URL в `.env.local`:
  // это нужно для локальной отладки против своего backend без правки кода.
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }

  switch (process.env.NODE_ENV) {
    case 'production':
      return 'https://api.drvdev.ru/';
      return 'https://api.drivechargers.ru/';
    case 'development':
    default:
      return 'https://api.drvdev.ru/';
  }
};

export const baseUrl = [baseUrlByEnvironment(), 'v1/'].join('');

export const graphqlUrl = [baseUrlByEnvironment(), 'graphql'].join('');

export const getJSON = (path, headers, params) => {
  let url = [baseUrl, path, '?'].join('');
  let i = 0;

  for (let name in params) {
    let value = params[name];
    url += `${name}=${value}`;
    i++;
    if (Object.keys(params).length !== i) {
      url += '&';
    }
  }

  return ajax(url, {
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
  });
};

export const postJSON = (path, headers, data) => {
  return ajax(baseUrl + path, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postFormData = (path, headers, data) => {
  return ajax(baseUrl + path, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      ...headers
    },
    processData: false,
    contentType: false,
    mimeType: 'multipart/form-data',
    referrer: 'no-referrer',
    body: data,
  });
};

export const putJSON = (path, headers, data) => {
  return ajax(baseUrl + path, {
    method: 'PUT',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

// Тело у DELETE опционально: удаление документа аренды требует основания,
// а в query его передавать нельзя — причина попадёт в логи и историю браузера.
export const deleteJSON = (path, headers, data) => {
  return ajax(baseUrl + path, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    ...(data ? {body: JSON.stringify(data)} : {}),
  });
};

export const postGraphql = (headers, data) => {
  return ajax(graphqlUrl, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const getAgreementsContents = (path) => {
  return ajax(baseUrl + 'help' + path, {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
  });
};

export const postAuthEmailVerify = (tokenBody) => {
  return ajax(baseUrl + 'auth/email/verify', {
    method: 'POST',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(tokenBody),
  });
};

export const getManagersList = (headers) => {
  return ajax(baseUrl + 'managers', {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
};

export const getAdminLogs = (headers) => {
  return ajax(baseUrl + 'managers/admin-logs', {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
};

export const getAdminUsersSearch = (headers, search, filters = {}) => {
  const params = [`search=${encodeURIComponent(search)}`];

  if (filters.role) {
    params.push(`role=${encodeURIComponent(filters.role)}`);
  }

  if (filters.excludeRole) {
    params.push(`exclude_role=${encodeURIComponent(filters.excludeRole)}`);
  }

  return ajax(baseUrl + `managers/users/search?${params.join('&')}`, {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
};

export const postAdminCompany = (headers, data) => {
  return ajax(baseUrl + 'managers/companies', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const getAdminCompanies = (headers) => {
  return ajax(baseUrl + 'managers/companies', {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
};

export const getAdminCompanyUsers = (companyId, headers) => {
  return ajax(baseUrl + `managers/companies/${companyId}/users`, {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
};

export const postAdminUserSharedAccount = (userId, headers, data) => {
  return ajax(baseUrl + `managers/users/${userId}/shared-account`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postManagerNews = (headers, data) => {
  return ajax(baseUrl + 'managers/news', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postAdminUserReplenishAccount = (userId, headers, data) => {
  return ajax(baseUrl + `managers/users/${userId}/replenish-account`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postOrderChangeOwner = (orderId, headers, data) => {
  return ajax(baseUrl + `orders/${orderId}/change_owner`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postManualPayment = (headers, data) => {
  return ajax(baseUrl + 'payments', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postOrderRefundParking = (orderId, headers) => {
  return ajax(baseUrl + `orders/${orderId}/refund_parking`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
  });
};

export const postOrderRefundSbpOverpayment = (orderId, headers) => {
  return ajax(baseUrl + `orders/${orderId}/refund_sbp_overpayment`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
  });
};

export const postOrderCheckSbpRefundStatus = (orderId, headers) => {
  return ajax(baseUrl + `orders/${orderId}/check_sbp_refund_status`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
  });
};

export const postChatPhoto = (chatId, headers, data) => {
  return ajax(baseUrl + `chats/${chatId}/photos`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      ...headers
    },
    processData: false,
    contentType: false,
    mimeType: 'multipart/form-data',
    referrer: 'no-referrer',
    body: data,
  });
};

export const getConnectorMeterValues = (station_id, evse_number, headers) => {
  return ajax(baseUrl + 'meter-values/' + `${station_id}/` + `${evse_number}`, {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
}

export const postResetStation = (station_id, headers) => {
  return ajax(baseUrl + `stations/${station_id}/reset`, {
    method: 'POST',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
}

export const postOpenLocationBarrier = (location_id, headers) => {
  return ajax(baseUrl + `locations/${location_id}/barrier/toggle`, {
    method: 'POST',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
}

export const postLocationPricing = (location_id, data, headers) => {
  return ajax(baseUrl + `locations/${location_id}/pricing`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postStartCharging = (id, data, headers) => {
  return ajax(baseUrl + `connectors/${id}/start`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
};

export const postStopCharging = (id, headers) => {
  return ajax(baseUrl + `connectors/${id}/stop`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify({}),
  });
};

export const getOcppMessages = (station_id, headers) => {
  return ajax(baseUrl + 'ocpp-messages/' + `${station_id}`, {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
}

export const getOcppLogs = (station_id, connector_id, headers) => {
  return ajax(baseUrl + 'ocpp-messages/' + `${station_id}` + '/controller' + (connector_id ? `?connector_id=${connector_id}` : ''), {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
}

export const deleteOcppLogs = (station_id, headers) => {
  return ajax(baseUrl + 'ocpp-messages/' + `${station_id}` + '/controller', {
    method: 'DELETE',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
  });
}

export const postStationMessage = (station_id, data, headers) => {
  return ajax(baseUrl + 'stations/' + `${station_id}/message`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
}

export const postStationDescription = (data, headers) => {
  return ajax(baseUrl + 'stations/description', {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    crossDomain: true,
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      ...headers
    },
    processData: false,
    referrer: 'no-referrer',
    body: JSON.stringify(data),
  });
}

export const postAntiSanctionVersion = (data, headers) => {
    return ajax(baseUrl + 'anti-sanction-protection/versions', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        crossDomain: true,
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            ...headers
        },
        processData: false,
        referrer: 'no-referrer',
        body: JSON.stringify(data),
    });
}

export const getAntiSanctionVersions = (headers) => {
    return ajax(baseUrl + 'anti-sanction-protection/versions', {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        crossDomain: true,
        credentials: 'same-origin',
        processData: false,
        referrer: 'no-referrer',
        headers,
    });
}

export const getStatisticsReport = (headers, mode, from, to, locations) => {
  return ajax(baseUrl + `statistics/report?mode=${mode}&locationIds=${locations || ''}&from=${from}&to=${to}`, {
    method: 'GET',
    mode: 'cors',
    crossDomain: true,
    credentials: 'same-origin',
    processData: false,
    referrer: 'no-referrer',
    headers,
  });
}
